import { withDevtools, withGlitchTracking } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import { initialEngineReportsState } from '@navstation-portal/reporting/data-model/engine-reports';
import { signalStore, withComputed, withState } from '@ngrx/signals';
import { buildEngineReportsVm } from './engine-reports-vm-builder';
import { withEngineReportsEffects } from './with-engine-reports-effects';
import { withEngineReportsReducer } from './with-engine-reports-reducer';

export const EngineReportsStore = signalStore(
  { providedIn: 'root' },
  withDevtools('EngineReportsStore', withGlitchTracking()),
  withState(initialEngineReportsState),
  withEngineReportsEffects(),
  withEngineReportsReducer(),
  withComputed((store) => ({
    vm: computed(() => buildEngineReportsVm(store.meReports(), store.aeReports())),
  }))
);
